export default __webpack_public_path__ + "static/media/128.2ae6ff14.png";